import { Component, Input, NgModule } from '@angular/core';
import { Employee, Farm, GetUsersResponseType, Product, Review, SendCustomerInfo } from '../../../models/types';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProfilePageService } from '../../services/profile-page.service';
import { MarketPageService } from '../../services/market-page.service';
import { NgxCaptchaModule } from 'ngx-captcha';
import { LoginService } from '../../services/login.service';
import { CommonModule } from '@angular/common';
import Swal from 'sweetalert2';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faStar, faSun, faTractor, faUser } from '@fortawesome/free-solid-svg-icons';
import { StarRatingModule } from 'angular-star-rating';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { RouterModule, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-product-details-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule, 
    ReactiveFormsModule, 
    NgxCaptchaModule, 
    FontAwesomeModule, 
    StarRatingModule,
    RouterModule,
    RouterOutlet,
  ],
  templateUrl: './product-details-modal.component.html',
  styleUrl: './product-details-modal.component.scss'
})
export class ProductDetailsModalComponent {
  @Input() product!: Product;
  @Input() farm!: Farm;

  newReview: Review = {
    userID: 0,
    productID: 0,
    reviewID: 0,
    rating: 0,
    comment: '',
    timestamp: '',
  };

  stars: number[] = [1, 2, 3, 4, 5];
  faStar = faStar;
  faSun = faSun;
  faUser = faUser;
  faTractor = faTractor;

  constructor(
    public activeModal: NgbActiveModal,
    private marketPageService: MarketPageService,
    private loginService: LoginService,
    private profilePageService: ProfilePageService)
  {}

  ngOnInit() {
    //this.loadUsernamesForReviews();
    console.log('Product:', this.product);
    console.log('Reviews:', this.product.reviews);
  }

  loadUsernamesForReviews() {
    if (this.product.reviews) {
      this.product.reviews.forEach(review => {
        this.fetchUsername(review.userID).subscribe(username => {
          review.username = username;
        });
      });
    }
  }

  fetchUsername(userID: number): Observable<string> {
    return new Observable(observer => {
      this.profilePageService.getUserProfile(userID).subscribe(
        (response: HttpResponse<GetUsersResponseType>) => {
          const username = response.body?.username || 'Unknown User';
          observer.next(username);
          observer.complete();
        },
        error => {
          observer.next('Unknown User');
          observer.complete();
        }
      );
    });
  }

  submitReview() {
    if (this.loginService.IsUserLoggedIn()) {
      this.newReview.userID = this.loginService.GetLoggedInUserInfo()!.userID;
      this.newReview.username = this.loginService.GetLoggedInUserInfo()!.username;
      this.newReview.timestamp = new Date().toISOString();
      console.log('Sending review to product owner:', this.newReview);
      
      this.marketPageService.sendReviewToProductOwner(this.product, this.newReview)
        .subscribe(
          (response) => {
            console.log('Review sent successfully:', response);
            this.activeModal.close(); // Close the modal after successful review send
            window.location.reload(); // Reload the page to show the new review
          },
          (error) => {
            console.error('Error sending review:', error);
    
            if (error.status === 422) {
              Swal.fire({
                title: 'Zaznan neprimeren jezik',
                text: 'Vaša ocena vsebuje neprimeren komentar. Prosim, poskusite znova.',
                icon: 'warning',
                confirmButtonText: 'OK'
              });
            } else {
              // Handle other types of errors
              Swal.fire({
                title: 'Error',
                text: 'An unexpected error occurred. Please try again later.',
                icon: 'error',
                confirmButtonText: 'OK'
              });
            }
          }
        );  
    }
    else {
      Swal.fire({
        title: 'Niste prijavljeni',
        text: 'Za oddajo ocene se morate prijaviti.',
        icon: 'warning',
        confirmButtonText: 'OK'
      });
    }
  }

  closeModal() {
    this.activeModal.dismiss('cancel');
  }

  onRatingChange(event: { rating: number }) {
    this.newReview.rating = event.rating; // Adjust according to the actual event structure
    console.log('New rating:', this.newReview.rating);
  
    // Optionally, save the rating to a backend or perform other actions
  }

  isEmployee(userID: number): boolean {
    return this.farm.employees.some(employee => employee.employeeID === userID);
  }
}
